import React from 'react';

export default function About() {
  return (
    <main className="wideContainer aboutPage">
      <section className="aboutIntro">
        <h1>About Digital Receipts Platform</h1>
        <p>
          Welcome to the Digital Receipts Platform — a secure, modern, and mobile-friendly
          digital transaction solution designed to improve trust, transparency, and
          traceability across supply chains and commercial ecosystems.
        </p>
        <p>
          Initially developed with a strong focus on the African market, the platform is
          designed to support digital transformation in environments where accessibility,
          reliability, and simplicity are essential. The solution features a clean and
          intuitive user interface optimized for mobile devices and low-connectivity
          environments.
        </p>
      </section>

      <section className="aboutSection">
        <h2>Purpose of the Platform</h2>
        <p>Many industries still rely on paper-based transaction records that can be:</p>
        <ul>
          <li>Lost</li>
          <li>Damaged</li>
          <li>Difficult to verify</li>
          <li>Vulnerable to modification or fraud</li>
        </ul>
        <p>
          The Digital Receipts Platform enables organizations to digitize receipts and
          transaction records while ensuring that data remains secure, verifiable, and
          accessible to authorized stakeholders.
        </p>
        <p>The platform helps:</p>
        <ul>
          <li>Improve trust between transaction participants</li>
          <li>Reduce fraud and disputes</li>
          <li>Create transparent and auditable transaction histories</li>
          <li>Simplify operational workflows</li>
          <li>Improve traceability and accountability</li>
          <li>Support digital modernization initiatives</li>
        </ul>
        <p>
          The solution was initially designed for agricultural ecosystems and cooperative
          networks in Africa, but its architecture is adaptable to many other industries
          and operational environments.
        </p>
      </section>

      <section className="aboutSection">
        <h2>Multi-Industry Adaptability</h2>
        <p>
          Although agriculture is the first primary target sector, the platform can be
          customized and deployed for many other use cases, including:
        </p>
        <ul>
          <li>Logistics and transport</li>
          <li>Warehousing</li>
          <li>Commodity trading</li>
          <li>Supply-chain management</li>
          <li>Industrial traceability</li>
          <li>Cooperative management</li>
          <li>Procurement systems</li>
          <li>Field operations and inspections</li>
        </ul>
        <p>
          The platform architecture is intentionally flexible to adapt to the operational
          requirements of different organizations and industries.
        </p>
      </section>

      <section className="aboutSection">
        <h2>Secure Digital Ledger Technology</h2>
        <p>
          Each digital receipt or transaction record is protected using cryptographic
          verification technologies.
        </p>
        <p>When a transaction is created:</p>
        <ul>
          <li>Transaction data is transformed into a unique cryptographic hash</li>
          <li>Any modification to the original data changes the hash immediately</li>
          <li>Unauthorized alterations therefore become detectable</li>
        </ul>
        <p>
          This creates a secure digital ledger system designed to preserve transaction
          integrity between all participants.
        </p>
        <p>The platform also supports future integration with:</p>
        <ul>
          <li>Private permissioned blockchain infrastructures</li>
          <li>Consortium ledger networks</li>
          <li>Distributed audit systems</li>
        </ul>
        <p>
          This allows organizations, cooperatives, and institutions to progressively evolve
          toward more advanced distributed trust architectures while maintaining controlled
          access and privacy protections.
        </p>
      </section>

      <section className="aboutSection">
        <h2>Controlled Access and Privacy</h2>
        <p>The platform supports multiple user roles, including:</p>
        <ul>
          <li>Producers and field operators</li>
          <li>Buyers and commercial operators</li>
          <li>Cooperatives and organizations</li>
          <li>Administrators</li>
          <li>Government or regulatory authorities</li>
        </ul>
        <p>Access permissions can be customized to ensure:</p>
        <ul>
          <li>Users only access authorized information</li>
          <li>Shared transactions remain verifiable</li>
          <li>Sensitive operational data remains protected</li>
          <li>Administrative oversight remains possible where required</li>
        </ul>
      </section>

      <section className="aboutSection">
        <h2>Designed for African Deployment Realities</h2>
        <p>
          The platform is specifically designed with African operational realities in mind,
          including:
        </p>
        <ul>
          <li>Mobile-first usage</li>
          <li>Low-bandwidth connectivity</li>
          <li>Rural deployment environments</li>
          <li>Low-end Android devices</li>
          <li>Simplicity of use</li>
          <li>Fast and clean interfaces</li>
        </ul>
        <p>
          The objective is to provide a practical digital tool that can operate effectively
          in real field conditions while remaining affordable and scalable.
        </p>
      </section>
    </main>
  );
}
